var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('v-icon',{staticClass:"fas fa-pencil-alt pencil"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }